/**
 * Classe para gerenciar a funcionalidade de pesquisa no blog
 */
class BlogSearch {
    /**
     * Inicializa a instância BlogSearch
     */
    constructor() {
        // Elementos do DOM
        this.searchForm = document.getElementById('blogSearchForm');
        this.searchInput = document.getElementById('blogSearchInput');
        this.searchButton = document.getElementById('blogSearchButton');
        this.articlesContainer = document.getElementById('blogArticlesContainer');
        this.noResultsMessage = document.getElementById('blogNoResults');
        this.articles = document.querySelectorAll('.blog-articles__article');

        // Timeout para debounce
        this.searchTimeout = null;

        // Inicialização
        this.init();
    }

    /**
     * Configura os event listeners
     */
    init() {
        // Pesquisa quando o botão é clicado
        this.searchButton.addEventListener('click', () => this.filterArticles());

        // Pesquisa quando Enter é pressionado
        this.searchInput.addEventListener('keypress', (e) => {
            if (e.key === 'Enter') {
                e.preventDefault();
                this.filterArticles();
            }
        });

        // Pesquisa em tempo real enquanto digita (com debounce)
        this.searchInput.addEventListener('input', () => {
            // Cancela o timeout anterior para evitar execuções múltiplas
            if (this.searchTimeout) {
                clearTimeout(this.searchTimeout);
            }

            // Define um novo timeout de 300ms para executar a pesquisa
            this.searchTimeout = setTimeout(() => {
                this.filterArticles();
            }, 300);
        });
    }

    /**
     * Remove acentos de uma string
     * @param {string} text - O texto a ser normalizado
     * @return {string} - O texto sem acentos
     */
    removeAccents(text) {
        return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }

    /**
     * Filtra os artigos com base no termo de pesquisa
     */
    filterArticles() {
        const searchTerm = this.searchInput.value.toLowerCase().trim();
        let hasResults = false;

        // Se o campo de busca estiver vazio, mostra todos os artigos
        if (searchTerm === '') {
            this.showAllArticles();
            return;
        }

        // Filtra os artigos com base no termo de pesquisa
        this.articles.forEach(article => {
            if (this.articleMatchesSearch(article, searchTerm)) {
                this.showArticle(article);
                hasResults = true;
            } else {
                this.hideArticle(article);
            }
        });

        // Atualiza a mensagem de resultados
        this.updateResultsMessage(hasResults);
    }

    /**
     * Verifica se um artigo corresponde ao termo de pesquisa
     * @param {HTMLElement} article - O elemento do artigo
     * @param {string} searchTerm - O termo de pesquisa
     * @return {boolean} - Se o artigo corresponde ao termo
     */
    articleMatchesSearch(article, searchTerm) {
        const title = article.getAttribute('data-article-title') || '';
        const content = article.getAttribute('data-article-content') || '';

        // Normaliza o termo de pesquisa e o conteúdo removendo acentos
        const normalizedSearchTerm = this.removeAccents(searchTerm.toLowerCase());
        const normalizedTitle = this.removeAccents(title.toLowerCase());
        const normalizedContent = this.removeAccents(content.toLowerCase());

        return normalizedTitle.includes(normalizedSearchTerm) ||
            normalizedContent.includes(normalizedSearchTerm);
    }

    /**
     * Mostra um artigo
     * @param {HTMLElement} article - O elemento do artigo
     */
    showArticle(article) {
        article.style.display = '';
    }

    /**
     * Oculta um artigo
     * @param {HTMLElement} article - O elemento do artigo
     */
    hideArticle(article) {
        article.style.display = 'none';
    }

    /**
     * Mostra todos os artigos
     */
    showAllArticles() {
        this.articles.forEach(article => this.showArticle(article));
        this.noResultsMessage.style.display = 'none';
    }

    /**
     * Atualiza a mensagem de resultados
     * @param {boolean} hasResults - Se há resultados para exibir
     */
    updateResultsMessage(hasResults) {
        this.noResultsMessage.style.display = hasResults ? 'none' : 'block';
    }
}

// Inicializa a pesquisa do blog quando o DOM estiver carregado
document.addEventListener('DOMContentLoaded', function() {
    new BlogSearch();
});